import { render, staticRenderFns } from "./AuthHeader.vue?vue&type=template&id=0ce16220&"
import script from "./AuthHeader.vue?vue&type=script&lang=ts&"
export * from "./AuthHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AuthHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports